<div class="faixa-pedido-teste" *ngIf="pedidoTesteOnboarding" role="status">
  <strong>Pedido de teste</strong> · passa mesmo com a loja fechada e não conta como venda
</div>
<div id="div_container" [class.banner]="exibindoBanner" [class.com-faixa-teste]="pedidoTesteOnboarding">
  <router-outlet></router-outlet>
</div>
